import React from "react";
import { observer } from "mobx-react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";

import IconButton from "@mui/material/IconButton";
import { Update } from "@mui/icons-material";
import { getValueKey, getValueOfList } from "Utils";
import { TooltipIcon } from "TemplateCerere";

import "../index.css";

function Field6_Edit_LS(props) {
  const { row, updateRow, col, tableId, store, runEvent, isReadonly } = props;

  var controlType =
    ["select", "radio-v", "radio-h"/*, "button", "tab", "slider"*/].find(
      (e) => e === col.Jprop.control
    ) || "select";

  if (controlType === "select") {
    return (
      <div className="refresh-autocomplete">
        <Autocomplete
          id={`eac-${col.key}`}
          controled="true"
          options={col.visibleList(row)}
          getOptionLabel={(option) => getValueKey(option, 1)}
          //clearOnEscape
          //value={row ? getValueOfList(col.lista, row[col.key]) :null }
          value={row && row[col.key] != null
            ? getValueOfList(col.lista, row[col.key].toString())
            : null}
          //style={{ width: 350}}
          size="small"
          onChange={(event, newValue) => {
            updateRow(
              row,
              col.tip,
              col.key,
              newValue && getValueKey(newValue, 0),
              tableId
            );
          }}
          //autoComplete
          disabled={col.isReadonly || isReadonly}
          className={`doc-table-value${col.isReadonly || isReadonly ? " disabled" : ""
            }`}
          //sx={col?.eventProps?.style}
          label={col.inline && col.Caption}
          renderInput={(params) => (
            <TextField
              {...params}
              //label={col.headerText}
              variant="outlined"
            />
          )}
        />
        {col.hasButton && !(col.isReadonly || isReadonly) && (
          <IconButton
            aria-label="toggle "
            onClick={() => {
              runEvent(store, col, false, true, row);
            }}
            size="small"
          >
            <Update />
          </IconButton>
        )}
      </div>
    );
  }

  if (controlType === "radio-v" || controlType === "radio-h") {
    return (
      <FormControl
        component="fieldset"
        //error={isError}
        id={`eac-${col.key}`}
        //sx={col?.eventProps?.style}
      >
        {col.inline && (
          <FormLabel id={`eacfl-${col.key}`} component="legend">
            {col.inline && col.Caption}
            {col.Jprop?.infoLabel && (
              <TooltipIcon tooltip={col.Jprop?.infoLabel} />
            )}
          </FormLabel>
        )}
        <RadioGroup
          id={`eacf-${col.key}`}
          name={`eacf-${col.key}`}
          value={row && row[col.key] != null
            ? getValueOfList(col.lista, row[col.key].toString())[0]
            : null}
          row={controlType === "radio-h"}
          onChange={(event, newValue) => {
            updateRow(
              row,
              col.tip,
              col.key,
              newValue && getValueKey(newValue, 0),
              tableId
            );
          }}
        >
          {col.visibleList(row).map((value) => {
            var kv = getValueKey(value, 0);
            return (
              <FormControlLabel
                value={kv + ""}
                control={<Radio color="primary" />}
                label={getValueKey(value, 1)}
                key={kv}
                id={`eacf-${col.key}-${kv + ""}`}
                disabled={col.isReadonly || isReadonly}
              />
            );
          })}
        </RadioGroup>
      </FormControl>
    );
  }
  return controlType;
}
export default observer(Field6_Edit_LS);
